import { ExpectedDeliveryDateFormatter } from '@farmasiet/frontendcore-reactcomponents';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';

import { PictureProfile } from '../../../../ResizedImage/PictureProfile.csharp';
import { getTranslation, keys } from '../../../../Resources/Translations';
import { ExpectedDeliveryDateViewModel } from '../../../Purchase/Checkout/Delivery/DeliveryMethods/Common/ExpectedDelivery/ExpectedDeliveryDateViewModel.csharp';
import { DeliveryMethod } from '../../../Purchase/Checkout/Delivery/DeliveryMethods/DeliveryMethod.csharp';
import { ResponsivePicture } from '../../ResponsivePicture/ResponsivePicture';
import { expectedDeliveryDate } from '../ExpectedDeliveryDate';

interface IExpectedDeliveryDateMethodProps {
    method: ExpectedDeliveryDateViewModel;
    logoPictureProfile: PictureProfile;
    icon?: string;
    highlighted?: boolean;
    notAvailable?: boolean;
    deliveryInfoUrl: string;
    logCustomEvent: (name: string, properties?: { [key: string]: string }) => void;
}

export const ExpectedDeliveryDateMethod = observer((props: IExpectedDeliveryDateMethodProps) => {
    const isSelected = expectedDeliveryDate.selectedDeliveryMethod?.methodName === props.method.methodName;

    const deliveryMethodClassNames = classnames(
        'ExpectedDeliveryDateMethod',
        isSelected && 'ExpectedDeliveryDateMethod--Selected',
        props.highlighted && 'ExpectedDeliveryDateMethod--Highlighted',
        props.notAvailable && 'ExpectedDeliveryDateMethod--NotAvailable'
    );

    const selectMethod = () => {
        if (!props.highlighted && !props.notAvailable) {
            if (props.method.methodName !== expectedDeliveryDate.selectedDeliveryMethod?.methodName) {
                props.logCustomEvent('Selected expected delivery method', { Method: DeliveryMethod[props.method.method] });
                expectedDeliveryDate.selectDeliveryMethod(props.method);
            } else {
                props.logCustomEvent('Unselected expected delivery method', { Method: DeliveryMethod[props.method.method] });
                expectedDeliveryDate.unselectDeliveryMethod();
            }
        }
    };

    const deliveryTime = props.notAvailable ? (
        <>
            {getTranslation(keys['expectedDeliveryDate.notAvailable'])}{' '}
            {props.deliveryInfoUrl && <a href={props.deliveryInfoUrl}>{getTranslation(keys['expectedDeliveryDate.seeMore'])}</a>}
        </>
    ) : (
        <>
            {getTranslation(keys['expectedDeliveryDate.estimatedDeliveryTo'], [expectedDeliveryDate.postalCode])}:{' '}
            <b>{ExpectedDeliveryDateFormatter.formatDate(props.method.expectedDate)}</b>
        </>
    );

    return (
        <div className={deliveryMethodClassNames} key={props.method.methodName} onClick={!props.highlighted ? selectMethod : undefined}>
            {props.icon && <img className="ExpectedDeliveryDateMethod__Icon" src={props.icon} alt={props.method.methodName} />}

            <div className="ExpectedDeliveryDateMethod__Header">
                <div className="ExpectedDeliveryDateMethod__Details">
                    <div className="ExpectedDeliveryDateMethod__Logo">
                        <ResponsivePicture profile={props.logoPictureProfile} model={props.method.logo} />
                    </div>
                    <span className="ExpectedDeliveryDateMethod__Name">{props.method.methodName}</span>
                </div>
                <span className="ExpectedDeliveryDateMethod__CheckIndicator">
                    <span className="visuallyHidden">{getTranslation(keys['navigation.open'])}</span>
                </span>
            </div>
            <span className="ExpectedDeliveryDateMethod__DeliveryTime">{deliveryTime}</span>
        </div>
    );
});
